module.exports = __webpack_public_path__ + "img/minimalism.a6f7ae63.jpg";